import { useAppDispatch } from "../../app/hooks";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/user/userSlice";
import { useEffect, useState } from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import PrizaContainer from "../base/grid/PrizaContainer";
import { SurveyInfo } from "../../redux/survey/surveySlice";
import { retrieveSurveyList, selectSurveyList, surveyListSlice } from "../../redux/survey/surveyListSlice";
import { ObjectTarget } from "../../app/permissions";
import SurveyRow from "./SurveyRow";
import SurveyResult from "./SurveyResult";

interface SurveyReportProps {
    target: ObjectTarget;
    targetId: string;
}

const SurveyReport = (props: SurveyReportProps) => {
    const dispatch = useAppDispatch();
    // const navigate = useNavigate();
    const user = useSelector(selectUser);
    const surveyList = useSelector(selectSurveyList);
    // const massiveMessageUser = useSelector(selectMassiveMessageUser);
    // const messageDismissed = useSelector(selectMessageDismissed);

    const [selectedSurvey, setSelectedSurvey] = useState<SurveyInfo | null>(null);

    useEffect(() => {
        if (surveyList.request?.target && surveyList.request?.target != props.target
            && surveyList.request?.targetId != props.targetId
        ) {
            dispatch(surveyListSlice.actions.clean());
        }
        dispatch(retrieveSurveyList({ target: props.target, targetId: props.targetId }));
    }, [surveyList, props, user]);


    const list = surveyList.surveys || [];

    const open = (row: SurveyInfo) => {
        setSelectedSurvey(row);
    };

    const close = () => {
        setSelectedSurvey(null);
    };

    if (selectedSurvey) {
        return <SurveyResult survey={selectedSurvey} onClose={close} />;
    }

    const content = () => {
        return <TableContainer component={Paper} sx={{ m: 1 }}>
            <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Tipo</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Titulo</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Início</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Fim</TableCell>
                        <TableCell align="left" sx={{
                                color: (theme) => theme.palette.primary.contrastText,
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}>Status</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list.map((row) => (
                        <SurveyRow key={row.id} row={row} open={open}/>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>;
    };

    return <PrizaContainer
        state={surveyList.state}
        toolbar={{
            label: "Enquetes"
        }}
        messages={{
            empty: "Nenhuma enquete encontrada.",
            error: "Erro ao carregar enquetes."
        }}
        content={content}
        retry={() => { dispatch(surveyListSlice.actions.clean()); }}
    />;

};

export default SurveyReport;